import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import _ = require('underscore');
import { CampaignsService } from '../../campaigns/services/campaigns.service';
import { IImageCroppedState } from '../models/IImageCroppedState';
import { IImageError } from '../models/IImageError';

const minWidth = 640;
const maxWidth = 1200;

class AdImageSelectorComponent {
    public static $inject = ['$scope', '$timeout', 'campaignsService'];

    public imageCropped: ICroppedImage = {
        src: null,
        selector: {},
        minSize: null,
        maxSize: null,
        croppedImage: null,
        maxWidth: 600,
        scale: 1,
        aspectRatio: 2
    };

    public error: IImageError = {
        imageMinSize: false,
        fileType: false,
        imageFileSizeMinSize: false,
        fileSize: false,
        imageRequired: false,
        imageMinAreaSize: false
    };

    // bindings
    public state: IImageCroppedState;

    public options: { ratio: string };
    public waiting: boolean;

    public form: ng.IFormController;

    constructor(
        $scope: ng.IScope,
        private $timeout: ng.ITimeoutService,
        public campaignsService: CampaignsService
    ) {
        $scope.$watch(() => $('.imgcrop-area').width(), (width) => {
            if (width) {
                this.imageCropped.maxWidth = width;
            }
        });
        $scope.$watch(() => this.state.src, (value) => {
            if (value) {
                this.state.loading = true;
            } else {
                this.error.imageRequired = true;
            }
        });
    }

    public $onInit() {
        angular.element(document.querySelector('#fileInputCropped')).on('change', async (evt) => {
            await this.$timeout(0);
            const file = (evt.currentTarget as HTMLInputElement).files[0];

            this.state.src = null;

            this.error.fileSize = false;
            this.error.imageMinSize = false;
            this.error.fileType = false;

            if (!file) {
                this.state.valid = false;
                return;
            }

            if (!file.size || file.size > 5 * 1024 * 1024) {
                this.error.fileSize = true;
                this.state.valid = true;
                return;
            }

            this.state.loading = true;
            const reader = new FileReader();

            reader.readAsDataURL(file);

            reader.onload = async (evtreader) => {
                const target = evtreader.target as FileReader;
                await this.$timeout(0);
                const image = new Image();
                image.onload = async () => {
                    await this.$timeout(0);
                    if (image.width < this.imageCropped.minSize.w || image.height < this.imageCropped.minSize.h) {
                        this.state.src = null;
                        this.state.loading = false;
                        this.error.imageMinSize = true;
                        this.state.valid = false;
                    } else {
                        this.state.src = target.result as string;
                        this.state.valid = true;
                        this.form.$setDirty();
                    }
                };
                image.onerror = async () => {
                    await this.$timeout(0);
                    this.state.loading = false;
                    this.error.fileType = true;
                    this.state.valid = false;
                };
                image.src = target.result as string;
            };

            const element = evt.target as HTMLInputElement;
            element.value = '';
        });
    }

    public $onChanges() {
        this.options = {
            ratio: '2:1',
            ...this.options
        };
        const ratio = this.options.ratio.split(':').map((i) => parseInt(i, 10)).reduce((a, b) => a / b);
        this.imageCropped.aspectRatio = ratio;
        this.imageCropped.minSize = {
            w: minWidth,
            h: minWidth / ratio
        };
        this.imageCropped.maxSize = {
            w: maxWidth,
            h: maxWidth / ratio
        };
    }

    public onCropped(cropped: string) {
        if (!this.state.loading && cropped !== this.state.data) {
            this.form.$setDirty();
        }
        this.state.data = cropped || null;
        if (this.imageCropped.selector.imageSize) {
            this.validateSize();
        }
        if (this.state.id && (!this.state.serverImgLength || this.state.serverImgLength === 0)) {
            this.state.serverImgLength = _.size(cropped);
        }
        this.state.loading = false;
        this.state.dirty = this.state.serverImgLength !== _.size(cropped);
    }

    public clearCropped() {
        this.state.data = null;
        this.imageCropped.selector.clear();
    }

    public onLoadImgCrop = () => {
        this.state.loading = false;
        this.$timeout();
    }

    public needHelp = async () => {
        try {
            await this.campaignsService.needHelp();
        } catch (error) {
            return;
        }
    }

    private validate() {
        this.validateSize();
        this.error.imageRequired = !this.state.data;
    }

    private validateSize() {
        this.error.imageRequired = false;
        this.error.imageMinAreaSize = false;

        if (this.state.data != null && this.imageCropped.selector.size) {
            const w = this.imageCropped.selector.size.w ? this.imageCropped.selector.size.w : this.imageCropped.selector.imageSize.w;
            this.error.imageMinAreaSize = !(w >= this.imageCropped.minSize.w);
        } else if (this.state.data == null && this.state.src) {
            const validSelectorSize = angular.isDefined(this.imageCropped.selector.x1);

            this.error.imageMinAreaSize = !validSelectorSize;

            if (!validSelectorSize && this.imageCropped.selector.size) {
                this.imageCropped.selector.size.w = null;
            }
        }

        this.state.valid = !this.error.imageMinAreaSize;
    }

}

angular.module('naut').component('adImageSelector', {
    template: require('./ad-image-selector.component.html'),
    controller: AdImageSelectorComponent,
    controllerAs: 'ctrl',
    bindings: {
        state: '=',
        options: '=?',
        waiting: '<',
        error: '='
    },
    require: {
        form: '^form'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/marketplace/ad-image-selector/ad-image-selector.component.ts